<template>
  <div class="h-100">
    <cc-sidebar ref="sidebarRightFilter" id="sidebar-right-filter"
                title="Điều kiện tìm kiếm"
                @onOpenedSidebar="onOpenedSidebar">
      <template slot="body">
        <filter-panel ref="filterPanel" :path-name="pathName" @onChangeMultiSelect="onChangeMultiSelect"></filter-panel>
      </template>
      <template slot="footer">
        <div class="align-items-center p-3">
          <CRow>
            <CCol :col="{size: 10, offset: 1}">
              <CRow>
                <CCol col="6">
                  <CButton block color="danger" size="sm" @click="resetCondition">Xóa điều kiện</CButton>
                </CCol>
                <CCol col="6">
                  <CButton block color="success" size="sm" :disabled="isDisableFilterPanelSearch"
                           @click="filterListWithCondition">Tìm kiếm
                  </CButton>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </div>
      </template>
    </cc-sidebar>
    <CRow class="h-100">
      <CCol class="h-100 px-2">
        <cc-modal id="cc-modal-create-or-update"
                  :title="formData.type === 'update' ? 'Cập nhật giá trị' : 'Thêm mới giá trị'"
                  @onShowModal="onShowModal">
          <template slot="body">
            <validation-observer tag="form" ref="form" onsubmit="return false">
              <CRow class="mb-3" v-if="pathName === 'district'">
                <CCol>
                  <label for="input-slt-province">
                    Chọn cấp tỉnh
                    <span class="text-star-validate-01">*</span>
                  </label>
                  <validation-provider name="Cấp tỉnh" rules="required" v-slot="{valid, errors}">
                    <vue-multiselect id="input-slt-province" v-model="formData.province_obj" :options="provinceList"
                                     placeholder="-- Chọn cấp Tỉnh" label="name" track-by="id" @select="onSelectProvince"
                                     :multiple="false" :taggable="false"  aria-describedby="input-provinceId"></vue-multiselect>
                    <b-form-invalid-feedback id="input-provinceId">{{ errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </CCol>
              </CRow>
              <CRow class="mb-3" v-if="pathName === 'commune'">
                <CCol>
                  <label for="input-slt-district">
                    Chọn cấp huyện
                    <span class="text-star-validate-01">*</span>
                  </label>
                  <validation-provider name="Cấp huyện" rules="required" v-slot="{valid, errors}">
                    <vue-multiselect id="input-slt-district" v-model="formData.district_obj" :options="districtList"
                                     placeholder="-- Chọn cấp Huyện" label="name" track-by="id" @select="onSelectDistrict"
                                     :multiple="false" :taggable="false" aria-describedby="input-districtId"></vue-multiselect>
                    <b-form-invalid-feedback id="input-districtId">{{ errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </CCol>
              </CRow>
              <CRow class="mb-3">
                <CCol>
                  <label for="input-other-name">
                    Tên {{ otherTextMapping[pathName]['text'] }}
                    <span class="text-star-validate-01">*</span>
                  </label>
                  <validation-provider name="Tên" rules="required" v-slot="{valid, errors}">
                    <b-form-input id="input-other-name" v-model="formData.name"
                                  placeholder="Nhập tên..." trim
                                  aria-describedby="input-otherName"
                                  :state="!valid && errors[0] ? valid : null"
                                  @keydown.enter.prevent="keydownEnterModal">
                    </b-form-input>
                    <b-form-invalid-feedback id="input-otherName">{{ errors[0] }}</b-form-invalid-feedback>
                  </validation-provider>
                </CCol>
              </CRow>
            </validation-observer>
          </template>
          <template slot="footer">
            <div class="w-100 text-right">
              <CButton v-if="formData.type === 'update'" color="info" class="px-3 mr-2" @click="onUpdateItemOtherList">
                Cập nhật
              </CButton>
              <CButton v-else color="success" class="px-3 mr-2" @click="onCreateItemOtherList">
                Thêm mới
              </CButton>
              <CButton color="secondary" class="px-3" @click="closeModal">Đóng</CButton>
            </div>
          </template>
        </cc-modal>
        <cc-ve-table ref="ccVeTable" :namespace="pathName" :columns="columns" :scroll-width="1000"
                     :is-column-row-index="true" :is-column-expand="false" :is-show-pagination="false"
                     :cell-style-option="cellStyleOption" :event-custom-option="eventCustomOption"
                     @itemSelectedLength="getItemSelectedLength">
          <template slot="cCardHeader">
            <CRow>
              <CCol col="7">
                <h4 class="text-uppercase mb-0 mt-1">
                  Quản lý {{
                    pathName === 'province' ? 'cấp tỉnh' : (pathName === 'district' ? 'cấp huyện' : (pathName === 'commune' ? 'cấp xã' : title))
                  }}
                </h4>
              </CCol>
              <CCol col="5" class="float-right">
                <CRow>
                  <CCol :col="{size: 8, offset: 4}">
                    <CRow>
                      <CCol col="5">
                        <CButton block color="danger"
                                 :disabled="!itemSelectedLength"
                                 @click="deleteSelectedTable">
                          Xóa
                        </CButton>
                      </CCol>
                      <CCol col="5">
                        <CButton block color="success"
                                 @click="openModalCreateOrUpdate('cc-modal-create-or-update', null)">
                          Thêm mới
                        </CButton>
                      </CCol>
                      <CCol col="2" class="text-center align-self-center">
                        <CLink href="#" v-b-toggle.sidebar-right-filter>
                          <CIcon name="cil-filter" height="20"/>
                        </CLink>
                      </CCol>
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </template>
        </cc-ve-table>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import CcSidebar from '@/components/common/CcSidebar'
import FilterPanel from '@/components/other/FilterPanel'
import CcVeTable from '@/components/common/tableList/CcVeTable'
import CcModal from '@/components/common/CcModal'
import VueMultiselect from 'vue-multiselect'
import {OTHER_TEXT_MAPPING} from '@/common/Constant'
import {mapActions} from 'vuex'
import * as _ from 'lodash'

export default {
  name: "List",
  components: {
    VueMultiselect,
    CcModal,
    CcSidebar,
    FilterPanel,
    CcVeTable
  },
  data() {
    return {
      pathName: this.$route.path.substring(1).split('/')[1],
      title: this.$route.meta.title,
      otherTextMapping: OTHER_TEXT_MAPPING,
      isDisableFilterPanelSearch: false,
      itemSelectedLength: 0,
      deleteFailId: [],
      provinceList: [],
      districtList: [],
      formData: {
        type: '',
        name: ''
      },
      cellStyleOption: {
        bodyCellClass: ({row, column}) => {
          if (this.deleteFailId && this.deleteFailId.length) {
            if (this.deleteFailId.includes(row.id)) {
              if (['checkbox'].includes(column.type) || column.field === 'name') {
                return 'row-delete-failed cursor-pointer'
              } else {
                return 'row-delete-failed'
              }
            }
          } else {
            if (['checkbox'].includes(column.type) || column.field === 'name') {
              return 'cursor-pointer'
            }
          }
        }
      },
      eventCustomOption: {
        bodyCellEvents: ({row, column}) => {
          return {
            click: () => {
              if (column.field !== 'name') {
                const currentRowKey = row['id']
                this.$refs.ccVeTable.changeSelectedRowKeysByRowClick(currentRowKey)
              } else {
                this.openModalCreateOrUpdate('cc-modal-create-or-update', row)
              }
            }
          }
        }
      }
    }
  },
  methods: {
    ...mapActions('common', ['getLocationAndZoneTypeList']),
    resetCondition() {
      this.$refs.filterPanel.resetCondition()
    },
    onOpenedSidebar() {
      this.$refs.filterPanel.getUserListWhenOpenSidebar()
    },
    getItemSelectedLength(value) {
      this.itemSelectedLength = value
    },
    openModalCreateOrUpdate(id, rowSelected) {
      if (rowSelected) {
        _.merge(this.formData, rowSelected)
      } else {
        delete this.formData.id
        this.formData.name = ''
      }
      this.$bvModal.show(id)
    },
    async onShowModal() {
      if (['district', 'commune'].includes(this.pathName)) {
        await this.getLocationAndZoneTypeList()

        if (this.pathName === 'district') {
          if (Object.prototype.hasOwnProperty.call(localStorage, 'provinceList'))
            this.provinceList = JSON.parse(localStorage.getItem('provinceList'))
        } else if (this.pathName === 'commune') {
          if (Object.prototype.hasOwnProperty.call(localStorage, 'districtList'))
            this.districtList = JSON.parse(localStorage.getItem('districtList'))
        }
      }
      if (this.formData.id) {
        this.formData.type = 'update'
      } else {
        this.formData.type = 'create'
      }
    },
    closeModal() {
      this.$bvModal.hide('cc-modal-create-or-update')
    },
    keydownEnterModal() {
      if (this.formData.type === 'update') {
        this.onUpdateItemOtherList()
      } else {
        this.onCreateItemOtherList()
      }
    },
    onChangeMultiSelect(length) {
      if (['district', 'commune'].includes(this.pathName)) {
        this.isDisableFilterPanelSearch = !length
      } else {
        this.isDisableFilterPanelSearch = false
      }
    },
    filterListWithCondition() {
    },
    deleteSelectedTable() {
    },
    onCreateItemOtherList() {
    },
    onUpdateItemOtherList() {
    },
    onSelectProvince(selectedOption) {
      this.$refs.filterPanel.filter.provinceSelected = [selectedOption]
    },
    onSelectDistrict(selectedOption) {
      this.$refs.filterPanel.filter.districtSelected = [selectedOption]
    }
  }
}
</script>

<style scoped>

</style>
